// src/features/orders/OrderWorkspacePage.tsx
import { PageContainer } from '../../app/components/foundation';
import './styles/orders.css';

/**
 * The current approved backend contract exposes the paginated list only.
 * Do not render the legacy mock detail workspace when no real detail
 * contract exists.
 */
export function OrderWorkspacePage() {
  return (
    <PageContainer className="flex flex-col gap-6">
      <p className="vania-order-workspace-empty">
        جزئیات سفارش در قرارداد فعلی API در دسترس نیست.
      </p>
    </PageContainer>
  );
}
